import {EventBus} from "../../../common/eventBus";
import {resolve} from "../../../container";


export const HERO_TEASER_IMAGE_READY_EVENT = "hero-teaser-image-ready";

export class HeroTeaserImageReadyHandler {

    private hasElementsToObserve: boolean = false;
    private customCallback: () => void = () => {
    };

    public constructor(private imageSelector: string, private eventBus: EventBus = resolve(EventBus)) {
    }

    public hasImageElementsToObserve(): boolean {
        return this.hasElementsToObserve;
    }

    public onImageReady(callback: () => void): this {
        this.customCallback = callback;
        return this;
    }

    public installOn(heroTeaser: HTMLElement): this {
        const imageElements = heroTeaser.querySelectorAll(this.imageSelector);
        for (const imageElement of imageElements) {
            this.hasElementsToObserve = true;
            const imageEl = imageElement.querySelector<HTMLImageElement>("img");
            if (imageEl?.complete) {
                this.triggerImageReady();
            } else {
                heroTeaser.addEventListener("imageLoaded", () => this.triggerImageReady());
            }
        }

        return this;
    }

    public manuallyTriggerImageReady(): void {
        this.triggerImageReady();
    }

    private triggerImageReady(): void {
        this.eventBus.dispatchEvent(HERO_TEASER_IMAGE_READY_EVENT, {});
        this.customCallback();
    }
}